import axios from "axios";
import { errorMessage } from "./toastifyShowMessage";
import { HandleServicesError } from "./swalModal";
import { CheckToken, clearApp, clearAuthOnly, otpTokenForRequest, setAuthorization, setToken } from "./services";
import { delay } from "./tools";
import { activeToken, exitImpersonation, isImpersonating } from "./impersonation";
// ساختار دریافت و پست کردن دیتا
export const QueryAPI = async ({ url = "", parameters = {}, type = "post", contentType = "application/json; charset=utf-8", signal, silent = false }) => {
	let response = null;
	// impersonation token when "ورود به عنوان" is active in this tab, otherwise the user's own token
	setAuthorization(activeToken());
	// customer's OTP token (ConfirmOTPCode) as X-Second-Token; read per call so a refresh keeps it, dropped once expired
	const otpToken = otpTokenForRequest();
	const headers = { "Content-Type": contentType, ...(otpToken ? { "X-Second-Token": "Bearer " + otpToken } : {}) };
	try {
		const apiUrl = process.env.REACT_APP_API_KEY + url;
		if (type === "post") {
			response = await axios.post(apiUrl, parameters, { signal, timeout: 30000, headers });
		} else {
			response = await axios.get(apiUrl, { signal, timeout: 30000, headers });
		}
		if (response.data.HasError) {
			// وقتی silent باشه، toast خودکار نشون داده نمی‌شه و کد فراخوان خودش با antd message پیام واقعی رو نشون می‌ده
			if (!silent) {
				errorMessage(response.data.Message);
				return null;
			}
			return response.data;
		}
	} catch (error) {
		if (error?.response?.status === 401 && isImpersonating()) {
			// impersonation tokens have no refresh: the session ended or expired, go back to the operator
			await exitImpersonation({ callServer: false });
			return null;
		}
		if (error?.response?.status === 401) {
			try {
				// ⬇️ به‌جای پاک‌کردن همه‌چیز، اول رفرش کن
				const ok = await CheckToken();
				if (ok) {
					// ⬇️ یک‌بار دیگر همان ریکوئست را تکرار کن
					const apiUrl = process.env.REACT_APP_API_KEY + url;
					if (type === "post") {
						response = await axios.post(apiUrl, parameters, { signal, timeout: 30000, headers });
					} else {
						response = await axios.get(apiUrl, { signal, timeout: 30000, headers });
					}
				} else {
					// ⬇️ فقط احراز هویت را پاک کن؛ ویزاردها/پرسیست دست نخورند
					clearAuthOnly();
					window.location.href = "/";
					return null;
				}
			} catch {
				clearAuthOnly();
				window.location.href = "/";
				return null;
			}
		} else {
			// silent callers handle failures themselves (inline states, background badges)
			if (silent) return null;
			if (process.env.REACT_APP_DOMAIN === "dealer") {
				errorMessage(
					<div dir="ltr" style={{ textAlign: "left" }}>
						{error?.code} <br />
						{error?.message} <br />
						{error?.config?.url} <br />
					</div>,
				);
			} else {
				errorMessage("درحال حاضر سرویس در دسترس نمی‌باشد");
			}
			return null;
		}
	}
	return response ? response.data : null;
};

export * from "./api/public";
export * from "./api/security";
export * from "./api/report";
export * from "./api/crm";
export * from "./api/dealer";
